// Gestion d'un bouton de lecture et pause sur les vidéos
// Pour fonctionner la vidéo doit être encapsuler dans une balise <figure> comme le fait l'éditeur de Wordpress

// custom button
const videos = document.querySelectorAll('video');
const playButtonEl = document.querySelector('.play-button');
const videoFigure = document.querySelectorAll('figure.wpo-video');

videos.forEach((video) => {
    video.addEventListener('play', () => {
        let play = true
        displayPlayPauseButton(play);
    })
    
    video.addEventListener('pause', () => {
        let play = false
        displayPlayPauseButton(play);
    })
})


videoFigure.forEach((index) => {   
    const videoEl = index.querySelector('video');
    
    if (videoEl !== null) {

        videoEl.addEventListener('click', () => {
            let play = true;
            displayPlayPauseButton(play);
        })

        playButtonEl.addEventListener('click', () => {
            let play = false;
            displayPlayPauseButton(videoEl);
            videoEl.play();
        })
    }
})

function displayPlayPauseButton(play) {
    if(!play) {
        if ( playButtonEl.classList.contains('d-none') || playButtonEl.classList.contains('d-block')) {
            playButtonEl.classList.remove('d-none');
            playButtonEl.classList.add('d-block');
        }

    } else {
        if ( playButtonEl.classList.contains('d-none') || playButtonEl.classList.contains('d-block')) {
            playButtonEl.classList.remove('d-block');
            playButtonEl.classList.add('d-none');
        }
    }
}


// Fermeture des vidéos lorsqu'on ferme la modale
btnClose = document.querySelectorAll('.btn-close');

btnClose.forEach((currentBtn) => {
    currentBtn.addEventListener('click', () => {
        // videos = document.querySelectorAll('video');
        videos.forEach((video) => {
            video.pause();
        })
    })
})

const myModalEl = document.querySelector('.modal');
if (typeof(myModalEl) !== 'undefined' && myModalEl !== null) {
    myModalEl.addEventListener('hidden.bs.modal', () => {
        videos.forEach((video) => {
            video.pause();
        })
    })
}



